import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { IMPORT_ORDERS_ACTIONS } from '@usf/ngrx-order';
import { switchMap } from 'rxjs';
import { importFileAnalytics } from './import-order-upload-analytics.factories';
import { IMPORT_ORDER_UPLOAD_ANALYTICS_ACTIONS } from './import-order-upload-analytics.actions';

@Injectable({
  providedIn: 'root',
})
export class ImportOrderUploadAnalyticsEffects {
  importFile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IMPORT_ORDERS_ACTIONS.load),
      switchMap(payload => {
        return [
          IMPORT_ORDER_UPLOAD_ANALYTICS_ACTIONS.trackImportFile({
            tracking: importFileAnalytics(payload.fileType),
          }),
        ];
      }),
    ),
  );
  constructor(private actions$: Actions) {}
}
